import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import styles from '../PlayerPortalsOnSiteRegistrationAdminPanel.module.scss';

type Player = { id: string; name: string };

type PlayersSearchSelectProps = {
  players: Player[];
  selectedPlayerId: string;
  onPlayerChange: (selectedPlayerId: string) => void;
  placeholder?: string;
  error?: boolean;
  errorMessage?: string;
  onBlur?: () => void;
};

export const PlayersSearchSelect = ({
  players,
  selectedPlayerId,
  onPlayerChange,
  placeholder = 'Search player...',
  error = false,
  errorMessage,
  onBlur,
}: PlayersSearchSelectProps) => {
  const selectedPlayer =
    players.find(player => player.id === selectedPlayerId) || null;

  const handleChange = (_event: React.SyntheticEvent, value: Player | null) => {
    onPlayerChange(value?.id || '');
  };

  return (
    <Autocomplete
      options={players}
      value={selectedPlayer}
      onChange={handleChange}
      onBlur={onBlur}
      getOptionLabel={player => player.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      className={styles.playersSearchSelect}
      disablePortal
      ListboxProps={{ style: { maxHeight: 280 } }}
      renderInput={params => (
        <TextField
          {...params}
          placeholder={placeholder}
          size="small"
          error={error}
          helperText={error ? errorMessage : undefined}
        />
      )}
    />
  );
};
